const STATUS_ALIASES = Object.freeze({
  queued: 'pending',
  processing: 'running',
  succeeded: 'completed',
  success: 'completed',
  error: 'failed',
  canceled: 'cancelled',
});

export const TASK_STATUS_META = Object.freeze({
  pending: { labelKey: 'tasks.statuses.pending', variant: 'info', icon: 'Clock3', group: 'active' },
  running: { labelKey: 'tasks.statuses.running', variant: 'info', icon: 'Loader2', group: 'active', spin: true },
  awaiting_input: { labelKey: 'tasks.statuses.awaiting_input', variant: 'warning', icon: 'CircleHelp', group: 'attention' },
  completed: { labelKey: 'tasks.statuses.completed', variant: 'success', icon: 'CheckCircle2', group: 'finished' },
  failed: { labelKey: 'tasks.statuses.failed', variant: 'danger', icon: 'AlertTriangle', group: 'finished' },
  cancelled: { labelKey: 'tasks.statuses.cancelled', variant: 'neutral', icon: 'Square', group: 'finished' },
});

export function canonicalTaskStatus(status) {
  const rawStatus = String(status || '').trim().toLowerCase();
  return STATUS_ALIASES[rawStatus] || rawStatus || 'pending';
}

export function isCancelledTask(task) {
  return canonicalTaskStatus(task?.status) === 'cancelled'
    || String(task?.error || '').trim().toLowerCase() === 'cancelled by user';
}

export function taskStatusMeta(taskOrStatus) {
  if (typeof taskOrStatus === 'object' && isCancelledTask(taskOrStatus)) {
    return TASK_STATUS_META.cancelled;
  }
  const status = canonicalTaskStatus(
    typeof taskOrStatus === 'object' ? taskOrStatus?.status : taskOrStatus,
  );
  return TASK_STATUS_META[status] || TASK_STATUS_META.pending;
}

export function isTaskActive(task) {
  return taskStatusMeta(task).group === 'active';
}
